import { action } from 'typesafe-actions';
import * as Member from '../constants/Member';

export const loginAction = () => action(Member.LOGIN);
export const logoutAction = () => action(Member.LOGOUT);
export const setIsAppAction = (isApp = false) =>
    action(Member.SET_IS_APP, { isApp });
